<template>
  <div class="bomPrice__wrapper">
    <div class="bomPrice__qty">
      Qty:
      <span class="bomPrice__qtyValue">{{ item.DefaultQuantity }}</span>
    </div>
    <div v-if="isThirdPartyProduct" class="bomPrice__priceAndMsrp">
      <div v-if="isThirdPartyProduct" class="bomPrice__unit">
        <span class="bomPrice__unitNumbers">Included</span>
      </div>
    </div>
    <div v-else class="bomPrice__priceAndMsrp">
      <div v-if="getIsUserLoggedIn" class="bomPrice__priceAndMsrp">
        <div class="bomPrice__unit">
          <span class="bomPrice__unitNumbers">{{ getPrice }}</span>
        </div>
        <div class="bomPrice__msrp">
          MSRP:
          {{ getMsrp }}
        </div>
      </div>
      <!-- <div v-else class="bomPrice__login">
        <legrandav-link
          label="Sign in"
          size="16px"
          @click="onLoginClick"
        ></legrandav-link>
      </div> -->
    </div>
  </div>
</template>

<script>
import UtilityService from "../../../services/UtilityService";
import { mapGetters } from "vuex";

export default {
  props: {
    item: {
      Price: Object
    },
    deviceType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    ...mapGetters("enhancedBom", ["getCurrencySymbol"]),
    getPrice() {
      if (
        this.item?.Price?.FormattedMSRP === "TBD" &&
        this.item?.Price?.FormattedPrice === "TBD"
      ) {
        return "TBD";
      } else {
        const price = this.item.Price.RawPrice * this.item.DefaultQuantity;
        return UtilityService.formattedCurrencyString(
          price,
          this.getCurrencySymbol
        );
      }
    },
    getMsrp() {
      if (
        this.item?.Price?.FormattedMSRP === "TBD" &&
        this.item?.Price?.FormattedPrice === "TBD"
      ) {
        return "TBD";
      } else {
        const msrp = this.item.Price.RawMSRP * this.item.DefaultQuantity;

        return UtilityService.formattedCurrencyString(
          msrp,
          this.getCurrencySymbol
        );
      }
    },
    isThirdPartyProduct() {
      return true === this.item.IsThirdPartyProduct;
    }
  },
  methods: {
    onLoginClick() {
      UtilityService.openSignInMenu();
      this.$store.dispatch("enhancedproduct/updateEnhancedLocalStorage");
    },
    unquieId() {
      return this.item.Value ? this.item.Value : this.item.PartName;
    }
  }
};
</script>

<style lang="scss" scoped>
.bomPrice {
  &__wrapper {
    text-align: right;
    font-family: $font-family-sans-serif-regular;
  }
  &__unit {
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
  &__unitNumbers {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
  &__msrp {
    color: rgb(102, 103, 102);
    font-size: 12px;
    letter-spacing: 0.21px;
    line-height: 21px;
  }
  &__qty {
    color: rgb(102, 103, 102);
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
  &__qtyValue {
    color: rgb(51, 51, 51);
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
  &__login {
    a {
      color: $aqua;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
